export const SPACER_DEFAULTS = { height: 32 };
export const spacerWidget = {
    type: "spacer",
    defaultProps: SPACER_DEFAULTS,
    renderHtml(props) {
        const h = Math.max(0, Math.min(props.height, 800));
        return `<div class="emk-spacer" aria-hidden="true" style="height:${h}px"></div>`;
    },
};
//# sourceMappingURL=spacer.js.map